export function extendStickyHeader() {
    const stickyHeader = document.querySelector('.header--sticky-text');
    const stickyHeaderContent = document.querySelector('.header__content--sticky');
    if (stickyHeader) {
        stickyHeader.style.paddingBottom = `${stickyHeaderContent.offsetHeight / 2}px`;
    }
}
